import { Map } from "immutable";

export default {
  /**
   * 航跡管理追加
   *
   * @param state
   * @param payload
   * @constructor
   */
  CREATE: (state, payload) => {
    if(payload) {
      let list = state.list;

      state.list = list.set(payload.id, payload.data);
    }
  },
  /**
   * 航跡削除
   *
   * @param state
   * @param vesselId
   * @constructor
   */
  REMOVE: (state, vesselId) => {
    if(vesselId) {
      state.list = state.list.remove(vesselId);
    }
  },
  /**
   * 全データクリア
   *
   * @param state
   * @constructor
   */
  CLEAR: (state) => {
    state.list = Map()
  }
}
